import React from "react";

const VideoContext = React.createContext();
const useEffectContext = React.createContext();

export { VideoContext, useEffectContext };
